import { render } from "./index.vue?vue&type=template&id=cd72ee94&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cd72ee94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cd72ee94"

export default script